module.exports = __webpack_public_path__ + "141d4a85/img/send-icon.3cfb6275.svg";